var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"app"}},[_c('notifications'),_c(_vm.$route.meta.navBar,{tag:"component"}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }